export const ProductInfoDialogStyle = {
  titleBar: {
    backgroundColor: "#64b5f6",
    padding: "8px",
    textAlign: "center",
    position: "sticky", // スクロール固定
    top: 0, // 画面上部固定
    zIndex: 1000,
    width: "100%",
  },
  titleText: {
    color: "white",
    fontWeight: "bold",
  },
  leftButton: {
    backgroundColor: "#e0a56d",
    color: "white",
    fontWeight: "bold",
    minWidth: "140px",
    "&:hover": {
      backgroundColor: "#d79652",
    },
  },
  rightButton: {
    backgroundColor: "#2c2b3f",
    color: "white",
    fontWeight: "bold",
    minWidth: "100px",
    "&:hover": {
      backgroundColor: "#1f1e30",
    },
  },
  fbaItem: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 1,
    backgroundColor: "rgba(111, 185, 255, 0.28)",
    p: 2,
    borderRadius: 2,
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    width: "100%",
    maxWidth: 680,
    marginBottom: "16px",
  },
  keywordInput: {
    width: "500px",
    marginRight: "8px",
    backgroundColor: "rgb(255, 255, 255)",
  },
  searchButton: {
    whiteSpace: "nowrap",
  },
  syncButton: {
    whiteSpace: "nowrap",
    marginLeft: "24px",
  },

  // buttonWrapper: {
  //   display: "flex",
  //   justifyContent: "space-between",
  //   padding: "20px",
  // },
  // buttonWrapper: {
  //   display: "flex",
  //   justifyContent: "center", // ← ここを変更
  //   alignItems: "center",
  //   flexWrap: "wrap", // 必要に応じて
  //   gap: 3, // ボタン間の間隔調整
  //   padding: "20px",
  // },
  buttonWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 24px",
  },
  closeButton: {
    color: "#000",
    fontWeight: "bold",
    minWidth: 48,
    padding: "2px 8px",
    fontSize: "28px",
    lineHeight: 1,
  },
  orangeButton: {
    backgroundColor: "#e0a56d",
    color: "white",
    fontWeight: "bold",
    boxShadow: 3,
    "&:hover": {
      backgroundColor: "#d79652",
    },
  },
  floatingRegisterButton: {
    position: "absolute",
    bottom: 24, // ダイアログ下からの距離
    right: 24, // ダイアログ右からの距離
    width: 90,
    height: 90,
    borderRadius: "50%",
    backgroundColor: "#e0a56d",
    color: "white",
    fontWeight: "bold",
    boxShadow: 6,
    zIndex: 2000,
    "&:hover": {
      backgroundColor: "#d79652",
    },
  },
};
